import Logo from "../../components/Logo";
import Steps from "../../components/Steps";
import DynamicOffer from "../../components/DynamicOffer";
import Contacts from "../../components/Contacts";
import graphic from "../../assets/num1_graphic.png";
import icons from "../../assets/18+_gambleaware.png";
import { getDataByCountry, getTranslations } from "../../utils";
import { doRegistration } from "./helpers";
import "./styles.scss";

const { lang, country, mainSite, footertext } = getDataByCountry();
const lpLangData = getTranslations({ lang, footertext });

const data = [
  {
    top: lpLangData.step_1_title,
    sub: lpLangData.step_1_description,
  },
  {
    top: lpLangData.step_2_title,
    sub: lpLangData.step_2_description,
  },
  {
    top: lpLangData.step_3_title,
    sub: lpLangData.step_3_description,
  },
];

const Promo20Upto100 = () => {
  document.title = lpLangData.site_title;
  const offer =
    country === "GB" ? "Promo20spins_upto100GB" : "Promo20spins_upto100default";
  const currencyIcon = country === "GB" ? "£" : "$/€";

  return (
    <div className="num1" onClick={() => doRegistration(mainSite)}>
      <div className="upper">
        <div className="left">
          <Logo type="casino" />
          <DynamicOffer name={offer} />
        </div>
        <div className="right">
          <img src={graphic} alt="graphic" />
        </div>
      </div>
      <Steps
        stepData={{
          bgColor: "black",
          blockColor: "red",
          data,
        }}
      />
      <footer>
        <img src={icons} alt="begambleaware" />
        <div className="info">
          <Contacts />
          <p>Bonus Policy and Terms of Service apply.</p>
          <br />
          <br />
          <p>
            New depositing players only. Min. deposit: {currencyIcon}20. Max.
            bonus: {currencyIcon}100 + 20 Bonus Spins on Big Bass Bonanza. Offer
            valid on the first deposit. Winnings won with bonus spins that
            require a deposit have no wagering requirements. The match-up bonus
            that requires a deposit must be wagered 40x. Magic Red Welcome Bonus
            – 100% bonus on your first deposit up to {currencyIcon}100. This
            bonus only applies for deposits of {currencyIcon}20 or higher. Bonus
            Policy and Terms of Service apply. The “Welcome bonus” is limited to
            one bonus per household. The “Welcome bonus” may not be used in
            conjunction with any other bonus, promotion, or offer. The “Welcome
            bonus” must be wagered at{" "}
            <a href="http://magicred.com/">magicred.com</a> within 72 hours of
            being credited to your account.{" "}
            <a href="http://magicred.com/">magicred.com</a> reserves the right,
            at any time, to revoke any welcome bonus not used within the
            allotted period. In the interests of fair gaming, we require you to
            have wagered a minimum of 40 times the sum of your welcome bonus
            before cashing out any winnings. Wagering requirements T&Cs apply.
            Unless stated otherwise by{" "}
            <a href="http://magicred.com/">magicred.com</a>, the non-deposit
            bonus is available to new players only (players who have not
            received this bonus before). Our welcome bonus is automatic.
            However, there are various reasons for not receiving it, and you may
            need to personally request it. If you have not received your
            automatic welcome bonus after making an approved deposit, please
            contact our support team. This can be done online while you are
            playing (click the “online support” button) or by emailing{" "}
            <a href="mailto:support@magicred.com">support@magicred.com</a>. Just
            remember to state your username. Bonus Policy and Terms of Service
            apply. All spins credited to a player’s account must be used within
            24 hours from when the offer was granted. Unused spins will be
            removed from the account thereafter. Bonus spins are valued at{" "}
            {currencyIcon}0.10 per spin. Spins must be wagered before any
            winnings can be cashed out. The Spins bonus is calculated as the
            total value of the winnings received through the use of the spins.
            The total value of such credit shall be subject to the wagering
            requirements set out below. Any and all spins bonuses shall be
            subject to the standard bonus policy detailed hereby. Players who
            initiate a deposit to receive spins as part of a deposit offer MUST
            wager their deposit amount before initiating a withdrawal. Players
            who withdraw their deposit without wagering will lose the spins
            received from the deposit or, if used, any winnings received from
            the spins. The above terms also apply to 20 Spins ON YOUR FIRST
            DEPOSIT. For more details, please see our FAQ page. Deposits may be
            withdrawn before a player’s wagering requirements have been
            fulfilled. However, if this occurs, all bonuses and winnings will be
            voided/removed from the player’s account. Players must contact
            support to withdraw their deposit. Gambling can be addictive; please
            play responsibly.
          </p>
          <br />
          <br />
          <p>
            Copyright 2025 - All Rights Reserved. The games on this website are
            powered and operated by Aspire Global International LTD., a Malta
            based company with registration number C42296 and having registered
            office at 135, High street, Sliema SLM 1549, Malta, which is a fully
            licensed operator under the Remote Gaming Regulations of Malta
            (MGA/CL1/408/2007 issued on the 17 August 2009, MGA/CL1/876/2013
            issued on the 19 September 2013, MGA/CL1/1000/2014 issued on the
            20th of August 2014, MGA/CL1/1142/2015 issued on the 26th January
            2016, MGA/CL1/1174/2016 issued on the 26th May 2016) and regulated
            by the Malta Gaming Authority. In Great Britain only, the games on
            this website are operated by AG Communications Limited, a Malta
            based company with registration number C48328 and having registered
            office at 135, High street, Sliema SLM 1549, Malta, which is
            licensed and regulated by the United Kingdom Gambling Commission
            (Remote Gaming License Number 000-039483-R-319409-001).The current
            status of operators license can be found{" "}
            <a href="https://secure.gamblingcommission.gov.uk/gccustomweb/PublicRegister/PRSearch.aspx?ExternalAccountId=39483">
              by clicking here
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Promo20Upto100;
